<template>
   <div class="content-wrapper p-0">
      <app-overlay-loader v-if="preloader"/>
      <app-onboarding-site-editor
                v-if="selectedId != 1 && selectedSiteUrl && selectedId"
                :selectedUrl="selectedSiteUrl"
                :selectedId="selectedId"
                :user="userInfo"
                :uploadedImage="uploadedImage"
                @getImageAction="getSelectedImagesAction">
        </app-onboarding-site-editor>
        <form-editor-files
                :selectedId="selectedId"
                :selectedAction="selectedAction"
                @getUploadedImage="getUploadedImages">
        </form-editor-files>
   </div>
</template>


<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import {UserMixin} from "../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import * as actions from '../../../../Config/ApiUrl';

    export default {
        name: "EmployeeWiki",
        mixins: [FormMixin,UserMixin],
        data() {
            return {
               preloader: true,
               finishedGetData: false,
               selectedId: 1,
               selectedSiteUrl: "",
               impersonate: true,
               selectedAction: '',
               uploadedImage: {},
            }
        },

        created() {
            this.selectedId = parseInt(this.getSiteId());
            this.selectedSiteUrl = actions.SITE_ONBOARDING_DATA+'/'+this.selectedId;
        },
        methods: {
            getUrlParameter(name, url) {
                if (!url) url = location.href;
                name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
                var regexS = "[\\?&]"+name+"=([^&#]*)";
                var regex = new RegExp( regexS );
                var results = regex.exec( url );
                return results == null ? null : results[1];
            },
            getSelectedImagesAction(place) {
                console.log('click! '+place);
                this.selectedAction = place;
            },
            getUploadedImages(response) {
                console.log('uploaded!'+response);
                this.uploadedImage = response;
                this.selectedAction = ''; // Hide modal
            },
            getSiteId() {
                var url = window.location.href;
                return url.substring(url.lastIndexOf('/') + 1);
            },
        }
    }
</script>
